import React, { useEffect, useState } from "react";
import DropDownMenu from "../components/DropDownMenu";
import Button from "../components/Button";
import {
  getMappings,
  saveAsMappings,
  getOutputColumnsData,
  getChangesFlag,
  getEditStateData,
  setunSavedRulesChanges,
} from "../store/workspaceSlice";
import { rulesProperties, allowedRules, showAddedRulesToast } from "../helpers";
import { useSelector, useDispatch } from "react-redux";
import InputField from "../components/InputField";
const initializeDuplicateObject = {
  outputColumn: "",
  appliedRule: 6,
  useOutputOf: null,
  output: null,
  duplicateNTimes: 0,
};

const DuplicateEntries = () => {
  const dispatch = useDispatch();
  const currentMaps = useSelector(getMappings);
  const outputColsData = useSelector(getOutputColumnsData);
  const [duplicateObject, setDuplicateObject] = useState(
    initializeDuplicateObject,
  );
  const state = useSelector(getEditStateData);
  const [isInLocalEditMode, setIsInLocalEditMode] = useState(false);
  const USfalg = useSelector(getChangesFlag); // unsaved changes flag

  useEffect(() => {
    if (state?.type === "duplicate") {
      setDuplicateObject((prev) => ({ ...prev, ...state.data }));
      setIsInLocalEditMode(true);
    }
  }, [state?.data, state.type, state?.data?._id]);

  const handleOnChange = (e) => {
    setDuplicateObject((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
    if (!USfalg) {
      dispatch(setunSavedRulesChanges(true));
    }
  };

  const handleAddNewRule = () => {
    dispatch(
      saveAsMappings({
        ...duplicateObject,
      }),
    );
    showAddedRulesToast(
      duplicateObject.appliedRule,
      isInLocalEditMode ? "updated" : "added",
    );
    reset();
  };
  const reset = () => {
    setDuplicateObject(initializeDuplicateObject);
    setIsInLocalEditMode(false);
  };

  return (
    <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-4 p-2">
      <DropDownMenu
        label={"Select Output Column"}
        name="outputColumn"
        value={duplicateObject.outputColumn}
        options={outputColsData.map((item) => ({
          label: item.outColChr,
          value: item.outColChr,
        }))}
        onChange={handleOnChange}
      />
      <DropDownMenu
        label={"Use Output of previous Rule"}
        name="useOutputOf"
        value={duplicateObject.useOutputOf || ""}
        options={currentMaps
          .filter((item) => allowedRules.includes(item.appliedRule))
          .map((item) => ({
            label: `${item._id} :  ${
              item.appliedRule
                ? rulesProperties[item?.appliedRule].ruleName
                : item.ruleName
            }`,
            value: parseInt(item._id),
          }))}
        onChange={handleOnChange}
      />
      <InputField
        label={"Duplicate Number of Times"}
        name={"duplicateNTimes"}
        type="Number"
        placeholder={"Enter duplicate number"}
        value={duplicateObject.duplicateNTimes}
        onChange={(e) => {
          let value = e.target.value;
          value = value < 0 ? value * -1 : value;
          e.target.value = value;
          handleOnChange(e);
        }}
      />

      <div className="mt-4 col-span-2 flex gap-2">
        <Button
          btnText={`${isInLocalEditMode ? "Update" : "Save"}`}
          handleOnClick={handleAddNewRule}
          disabled={
            duplicateObject.outputColumn === "" ||
            (duplicateObject.duplicateNTimes && !duplicateObject.useOutputOf)
          }
        />
        <Button btnText={"Reset"} btnType={"cancel"} handleOnClick={reset} />
      </div>
    </div>
  );
};

export default DuplicateEntries;
